import api from './index'
import { axios } from '@/utils/request'

export function deleteTask (task_id) {
  return axios({
    url: api.DeleteTask + '/' + task_id,
    method: 'delete'
  })
}

export function getMyTaskList (params) {
  return axios({
    url: api.MyTaskList,
    method: 'get',
    params: params
  })
}

export function getManagerTaskList (params) {
  return axios({
    url: api.ManagerTaskList,
    method: 'get',
    params: params
  })
}

export function confirmTask (params) {
  return axios({
    url: api.Confirm,
    method: 'post',
    params: params
  })
}

export function getMemberLocalLabel (params) {
  return axios({
    url: api.MemberLocalLabel,
    method: 'get',
    params: params
  })
}

export function getMemberGlobalLabel (params) {
  return axios({
    url: api.MemberGlobalLabel,
    method: 'get',
    params: params
  })
}
